import script from "./EmojiPickerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EmojiPickerComponent.vue?vue&type=script&setup=true&lang=js"

import "./EmojiPickerComponent.vue?vue&type=style&index=0&id=240b1a3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-240b1a3c"]])

export default __exports__